module.exports = __webpack_public_path__ + "static/media/1_A1_04.fcb1c46f.png";